export * from './account.service';
import { AccountService } from './account.service';
export * from './action.service';
import { ActionService } from './action.service';
export * from './actionPoint.service';
import { ActionPointService } from './actionPoint.service';
export * from './admin.service';
import { AdminService } from './admin.service';
export * from './auth.service';
import { AuthService } from './auth.service';
export * from './backing.service';
import { BackingService } from './backing.service';
export * from './certificationProposal.service';
import { CertificationProposalService } from './certificationProposal.service';
export * from './comment.service';
import { CommentService } from './comment.service';
export * from './commentIdea.service';
import { CommentIdeaService } from './commentIdea.service';
export * from './commentProblem.service';
import { CommentProblemService } from './commentProblem.service';
export * from './feedback.service';
import { FeedbackService } from './feedback.service';
export * from './general.service';
import { GeneralService } from './general.service';
export * from './healthCheck.service';
import { HealthCheckService } from './healthCheck.service';
export * from './idea.service';
import { IdeaService } from './idea.service';
export * from './imageUpload.service';
import { ImageUploadService } from './imageUpload.service';
export * from './invitation.service';
import { InvitationService } from './invitation.service';
export * from './maintenance.service';
import { MaintenanceService } from './maintenance.service';
export * from './marketSector.service';
import { MarketSectorService } from './marketSector.service';
export * from './member.service';
import { MemberService } from './member.service';
export * from './membership.service';
import { MembershipService } from './membership.service';
export * from './messageGroup.service';
import { MessageGroupService } from './messageGroup.service';
export * from './nft.service';
import { NftService } from './nft.service';
export * from './notifications.service';
import { NotificationsService } from './notifications.service';
export * from './problem.service';
import { ProblemService } from './problem.service';
export * from './proposition.service';
import { PropositionService } from './proposition.service';
export * from './rating.service';
import { RatingService } from './rating.service';
export * from './share.service';
import { ShareService } from './share.service';
export * from './statistics.service';
import { StatisticsService } from './statistics.service';
export * from './tag.service';
import { TagService } from './tag.service';
export * from './userManagement.service';
import { UserManagementService } from './userManagement.service';
export * from './userRelations.service';
import { UserRelationsService } from './userRelations.service';
export * from './userSettings.service';
import { UserSettingsService } from './userSettings.service';
export * from './userTracking.service';
import { UserTrackingService } from './userTracking.service';
export * from './videoUpload.service';
import { VideoUploadService } from './videoUpload.service';
export * from './webHook.service';
import { WebHookService } from './webHook.service';
export const APIS = [AccountService, ActionService, ActionPointService, AdminService, AuthService, BackingService, CertificationProposalService, CommentService, CommentIdeaService, CommentProblemService, FeedbackService, GeneralService, HealthCheckService, IdeaService, ImageUploadService, InvitationService, MaintenanceService, MarketSectorService, MemberService, MembershipService, MessageGroupService, NftService, NotificationsService, ProblemService, PropositionService, RatingService, ShareService, StatisticsService, TagService, UserManagementService, UserRelationsService, UserSettingsService, UserTrackingService, VideoUploadService, WebHookService];
